interface GetCallbackIntentsParams {
  shippingOptionRequired: boolean;
}

export const PAYMENT_AUTHORIZATION = 'PAYMENT_AUTHORIZATION' as const;
export const SHIPPING_ADDRESS = 'SHIPPING_ADDRESS' as const;
export const SHIPPING_OPTION = 'SHIPPING_OPTION' as const;

export const getCallbackIntents = (
  params: GetCallbackIntentsParams,
): google.payments.api.PaymentDataRequest['callbackIntents'] => {
  const callbackIntents = [PAYMENT_AUTHORIZATION, SHIPPING_ADDRESS];

  // If PaymentDataRequest.callbackIntents contains SHIPPING_OPTION, PaymentDataRequest.shippingOptionRequired must be set to true!
  if (params.shippingOptionRequired) {
    return [...callbackIntents, SHIPPING_OPTION];
  }

  return callbackIntents;
};
